import React, { Component } from 'react';
import { showModal } from 'shared/actions/ModalActions';
import Question from './Question';
import HasConditionalIndicator from './HasConditionalIndicator';

const newQuestion = () => ({
  answerOptions: [],
  prompt: '',
  elementType: '',
  required: false,
  defaultVisible: true,
});

class Section extends Component {
  constructor(props, context) {
    super(props, context);
    this.updateQuestion = this.updateQuestion.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
    this.updateIncludeNotes = this.updateIncludeNotes.bind(this);
    this.updateDefaultVisibility = this.updateDefaultVisibility.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.removeQuestion = this.removeQuestion.bind(this);
    this.promoteQuestion = this.promoteQuestion.bind(this);
    this.demoteQuestion = this.demoteQuestion.bind(this);
    this.updateConditionalGroup = this.updateConditionalGroup.bind(this);
    this.removeConditionalGroup = this.removeConditionalGroup.bind(this);
    this.showConditionalModal = this.showConditionalModal.bind(this);
  }

  updateQuestion(idx, newValue) {
    const newQuestions = this.props.section.questions.map((question, i) => {
      if (i === idx) return newValue;
      return question;
    });
    this.props.onChange({ ...this.props.section, questions: newQuestions });
  }

  updateTitle(e) {
    this.props.onChange({ ...this.props.section, title: e.target.value });
  }

  updateIncludeNotes(e) {
    this.props.onChange({ ...this.props.section, suppressNotes: !e.target.checked });
  }

  updateDefaultVisibility(e) {
    this.props.onChange({ ...this.props.section, defaultVisible: e.target.checked });
  }

  addQuestion() {
    this.props.onChange({
      ...this.props.section,
      questions: this.props.section.questions.concat(newQuestion()),
    });
  }

  removeQuestion(idx) {
    this.props.onChange({
      ...this.props.section,
      questions: this.props.section.questions.filter((question, i) => i !== idx),
    });
  }

  promoteQuestion(idx) {
    if (idx > 0) {
      const questions = this.props.section.questions;
      this.props.onChange({
        ...this.props.section,
        questions: questions
          .slice(0, idx - 1)
          .concat([questions[idx], questions[idx - 1]])
          .concat(questions.slice(idx + 1)),
      });
    }
  }

  demoteQuestion(idx) {
    if (this.props.section.questions[idx + 1]) {
      this.promoteQuestion(idx + 1);
    }
  }

  // NOTE: This updates the Conditional for the Section, not for a question
  updateConditionalGroup(data) {
    this.props.onChange({
      ...this.props.section,
      visibilityConditionalGroup: data.conditionalGroup,
      visibilityThenAction: data.thenAction,
    });
  }

  removeConditionalGroup() {
    this.props.onChange({
      ...this.props.section,
      visibilityConditionalGroup: null,
      visibilityThenAction: null,
    });
  }

  // NOTE: This is to show the conditional modal for a Section, not a question
  showConditionalModal() {
    showModal({
      name: 'questionnaireItemConditionalGroupModal',
      conditionalGroup: this.props.section.visibilityConditionalGroup,
      thenAction: this.props.section.visibilityThenAction,
      updateConditionalGroup: this.updateConditionalGroup,
      removeConditionalGroup: this.removeConditionalGroup,
      rulableFields: this.props.rulableFields,
    });
  }

  render() {
    const { errorCollection, idx, section, remove, promote, demote, rulableFields } = this.props;
    const hasConditional = !!section.visibilityConditionalGroup;

    return (
      <div className="ec-form-section">
        {errorCollection && errorCollection.errors && errorCollection.errors.length ? (
          <div style={{ color: 'red' }}>
            <ul>
              {errorCollection.errors.map(error => (
                <li>{error}</li>
              ))}
            </ul>
          </div>
        ) : null}
        <div className="ec-form-section-header">
          <div className="ec-form-section-header-internal">
            {hasConditional ? <HasConditionalIndicator /> : 'Not conditional'}
            <div className="button-group">
              <button className="btn" type="button" onClick={this.addQuestion}>
                Add Question
              </button>
            </div>
            <div className="section-label-group">
              <label htmlFor={`section-name-${idx}`}>Section Name: </label>
              <div className="section-label-controls" style={{ marginLeft: '180px' }}>
                <input
                  id={`section-name-${idx}`}
                  onChange={this.updateTitle}
                  value={section.title}
                  type="text"
                  className="input-large"
                />
                <div className="btn-group">
                  <button className="btn" type="button" onClick={promote}>
                    <i className="icon-arrow-up" />
                  </button>
                  <button className="btn" type="button" onClick={demote}>
                    <i className="icon-arrow-down" />
                  </button>
                  <button
                    data-spec-class="remove-section-button"
                    className="btn btn-danger"
                    type="button"
                    onClick={remove}
                  >
                    <i className="icon-remove icon-white" />
                  </button>
                </div>
              </div>
            </div>
            <label>
              Include Notes:{' '}
              <input
                type="checkbox"
                checked={!section.suppressNotes}
                onChange={this.updateIncludeNotes}
              />
            </label>
            <label>
              Default Visble:{' '}
              <input
                type="checkbox"
                checked={!!section.defaultVisible}
                onChange={this.updateDefaultVisibility}
              />
            </label>
            <button onClick={this.showConditionalModal} className="btn btn-mini" type="button">
              {hasConditional ? 'Edit Conditional' : 'Add Conditional'}
            </button>
          </div>
        </div>

        <div className="ec-form-section-questions">
          {section.questions &&
            section.questions.map((question, idx) => (
              <Question
                errorCollection={errorCollection ? errorCollection.questions[idx] : null}
                key={idx}
                question={question}
                remove={() => this.removeQuestion(idx)}
                promote={() => this.promoteQuestion(idx)}
                demote={() => this.demoteQuestion(idx)}
                onChange={newValue => this.updateQuestion(idx, newValue)}
                rulableFields={rulableFields}
              />
            ))}
        </div>

        <div className="ec-form-section-footer">
          <button className="btn" type="button" onClick={this.addQuestion}>
            Add Question
          </button>
        </div>
      </div>
    );
  }
}

export default Section;
